import React from 'react';
import Icon from '../../../components/AppIcon';

const TopDealershipsPanel = ({ dealerships }) => {
  return (
    <div className="bg-card rounded-lg shadow-card border border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Top 10 Partner
          </h2>
          <Icon name="Trophy" size={24} color="var(--color-warning)" />
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Ranking nach Antragsanzahl
        </p>
      </div>
      <div className="p-6">
        <div className="space-y-4">
          {dealerships?.map((dealership, index) => (
            <div 
              key={dealership?.id}
              className="flex items-center gap-4 p-4 rounded-lg hover:bg-muted transition-smooth"
            >
              <div className={`flex items-center justify-center w-10 h-10 rounded-full font-heading font-bold text-lg ${
                index === 0 ? 'bg-warning/20 text-warning' :
                index === 1 ? 'bg-muted text-muted-foreground' :
                index === 2 ? 'bg-warning/10 text-warning': 'bg-muted/50 text-muted-foreground'
              }`}>
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-foreground truncate">
                  {dealership?.name}
                </h3>
                <p className="text-sm text-muted-foreground truncate">
                  {dealership?.location}
                </p>
              </div>
              <div className="text-right">
                <p className="text-lg font-heading font-semibold text-foreground">
                  {dealership?.applicationCount}
                </p>
                <p className="text-xs text-muted-foreground">Anträge</p>
              </div>
              {dealership?.trend && (
                <Icon 
                  name={dealership?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                  size={20} 
                  color={dealership?.trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopDealershipsPanel;